export default __webpack_public_path__ + "static/media/HV B2B Cat carpet.779b28a2.jpg";